import Head from 'expo-router/head';
import { Platform } from 'react-native';

import { IS_PRODUCTION } from '../../config/FruitfulEnvironment';

const META_DOMAIN_VERIFICATION_CODE = 'ickt4l4jy4hco3jmmzbrrqqhtez8v1';

/**
 * Proves to Meta that we own this domain. The tag is required for domain
 * verification in Meta Business Manager. It does not load the Meta pixel.
 * Meta scripts are handled by Google Tag Manager via GoogleTagManagerIntegration.
 * Mounted from the sign-up layout on web production.
 */
export const MetaIntegration = () => {
    if (!IS_PRODUCTION || Platform.OS !== 'web') return null;

    return (
        <Head>
            <meta
                name="facebook-domain-verification"
                content={META_DOMAIN_VERIFICATION_CODE}
            />
        </Head>
    );
};
